<template>
    <app-framework>
        <template v-slot:title>
            <tw-divider color="white"
                        width="56"
                        class="mb-3"
            ></tw-divider>
            Technical Requirements
        </template>
        <row class="z-10">
            <column cols="full">
                <tw-divider class="mb-5" color="primary" width="56"></tw-divider>
                <div class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl leading-higher">
                    Browser requirements
                </div>
                <div
                    class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed xs:w-full sm:w-3/4 md:w-1/2 lg:w-2/5">
                    The web application is available on:
                </div>
                <row class="mt-6" justify="center">
                    <column align="center" class="md:pr-5 mb-5 md:flex-1" md="1/3" sm="full" xs="full">
                        <card @click="goTo('https://www.google.com/chrome/')"
                              class="select-none cursor-pointer active:shadow-md"
                        >
                            <row justify="center">
                                <google-chrome :size="80" class="text-green-700"></google-chrome>
                            </row>
                            <div
                                class="xs:text-xl w-full text-center tracking-normal xs:leading-snug sm:leading-relaxed uppercase poppins-bold"
                            >Google Chrome
                            </div>
                        </card>
                    </column>
                    <column align="center" class="md:px-5 mb-5 md:flex-1" md="1/3" sm="full" xs="full">
                        <card @click="goTo('https://www.mozilla.org/en-US/firefox/new/')"
                              class="select-none cursor-pointer active:shadow-md"
                        >
                            <row justify="center">
                                <firefox :size="80" class="text-orange-600"></firefox>
                            </row>
                            <div
                                class="xs:text-xl w-full text-center tracking-normal xs:leading-snug sm:leading-relaxed uppercase poppins-bold"
                            >Mozilla Firefox
                            </div>
                        </card>
                    </column>
                    <column align="center" class="md:pl-5 md:flex-1" md="1/3" sm="full" xs="full">
                        <card @click="goTo('https://www.microsoft.com/en-us/edge')"
                              class="select-none cursor-pointer active:shadow-md"
                        >
                            <row justify="center">
                                <microsoft-edge :size="80" class="text-blue-600"></microsoft-edge>
                            </row>
                            <div
                                class="xs:text-xl w-full text-center tracking-normal xs:leading-snug sm:leading-relaxed uppercase poppins-bold"
                            >Microsoft Edge
                            </div>
                        </card>
                        <div
                            class="text-xs mt-3 text-gray-700 px-5">
                            *Only the latest version released early 2020 that is based on Chromium. Version number 80.0.361 or above.
                        </div>
                    </column>
                </row>
                <row class="mt-10" justify="center">
                    <tw-btn @click="goTo('https://journey.fitt.ai/#/test/video')"
                            color="secondary"
                            class="px-5"
                    >
                        <span class="text-white poppins-bold mt-1">Test Browser Support</span>
                    </tw-btn>
                </row>
                <row class="mt-20">
                    <div
                        class="xs:text-xl sm:text-2xl tracking-normal xs:leading-snug sm:leading-relaxed w-full text-center">
                        Alternatively, a fitt desktop application is available for Windows and MacOS.
                    </div>
                    <column cols="full">
                        <row class="mt-6" justify="center">
                            <column align="end" class="md:pr-5 mb-5 md:flex-1" md="1/2" sm="full" xs="full">
<!--                                <card @click="goTo('https://fitt-priv.s3.eu-west-1.amazonaws.com/binaries/fitt%20%281%29.msi?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIWBIIEKUCTAKXC6A%2F20200626%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20200626T124825Z&X-Amz-SignedHeaders=host&X-Amz-Expires=7200&X-Amz-Signature=a25007837ccbb30838378f86b76d87885df9e1ef14ac5fae4732b8ea6f82dcb3')"-->
                                <card @click="goTo('https://manage.fitt.ai/platforms/web01windo/downloadbinary')"
                                      class="select-none cursor-pointer active:shadow-md"
                                      style="max-width: 410px;"
                                >
                                    <row justify="center">
                                        <microsoft-windows :size="80" class="text-blue-600"></microsoft-windows>
                                    </row>
                                    <div
                                        class="xs:text-xl w-full text-center tracking-normal xs:leading-snug sm:leading-relaxed uppercase poppins-bold"
                                    >Microsoft Windows
                                    </div>
                                </card>
                            </column>
                            <column align="start" class="md:pl-5 mb-5 md:flex-1" md="1/2" sm="full" xs="full">
<!--                                <card @click="goTo('https://fitt-priv.s3.eu-west-1.amazonaws.com/binaries/fitt.dmg?X-Amz-Content-Sha256=UNSIGNED-PAYLOAD&X-Amz-Algorithm=AWS4-HMAC-SHA256&X-Amz-Credential=AKIAIWBIIEKUCTAKXC6A%2F20200626%2Feu-west-1%2Fs3%2Faws4_request&X-Amz-Date=20200626T130307Z&X-Amz-SignedHeaders=host&X-Amz-Expires=7200&X-Amz-Signature=58aba03b9500ed1a54040b6fc26b4521da7b7334051bfad4edf06432e9ad2681')"-->
                                <card @click="goTo('https://manage.fitt.ai/platforms/web01osx/downloadbinary')"
                                      class="select-none cursor-pointer active:shadow-md"
                                      style="max-width: 410px;"
                                >
                                    <row justify="center">
                                        <apple :size="80" class="text-gray-400"></apple>
                                    </row>
                                    <div
                                        class="xs:text-xl w-full text-center tracking-normal xs:leading-snug sm:leading-relaxed uppercase poppins-bold"
                                    >Mac OS
                                    </div>
                                </card>
                            </column>
                        </row>
                    </column>
                </row>
                <row>
                  <column cols="full" align="end" class="my-32">
                      <div class="poppins-bold tracking-normal text-right xs:text-3xl sm:text-5xl leading-higher">
                          Hardware requirements
                      </div>
                      <div
                          class="xs:text-xl sm:text-2xl tracking-normal text-right xs:leading-snug sm:leading-relaxed xs:w-full sm:w-3/4 md:w-1/2 lg:w-2/5">
                          The browser or application should have access to the webcam and microphone.
                      </div>
                  </column>
                    <column cols="full" align="start">
                        <div class="poppins-bold tracking-normal text-left xs:text-3xl sm:text-5xl leading-higher">
                            Whitelisting <a name="whitelisting"></a>
                        </div>
                        <div
                            class="xs:text-xl sm:text-2xl tracking-normal text-left xs:leading-snug sm:leading-relaxed xs:w-full sm:w-3/4 md:w-1/2 lg:w-2/5 mb-10">
                            All endpoints need to be whitelisted.
                        </div>
                        <card no-padding>
                            <table style="width: 100%; min-width: 700px;" cellpadding="15">
                                <thead class="bg-primary text-white uppercase poppins-bold">
                                <tr align="left">
                                    <th>Endpoint / IP range</th>
                                    <th>Port and Protocol</th>
                                    <th>Usage</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td><a href="ie1.vss.twilio.com" class="text-primary">ie1.vss.twilio.com</a></td>
                                    <td>443 WSS</td>
                                    <td>Integrated video interviewing</td>
                                </tr>
                                <tr>
                                    <td>
                                        52.215.253.0 - 52.215.253.63
                                        <br>
                                        54.171.127.192 - 54.171.127.255
                                        <br>
                                        52.215.127.0 - 52.215.127.255
                                        <br>
                                        3.249.63.128 - 3.249.63.255
                                    </td>
                                    <td>
                                        10,000 - 60,000
                                        <br>
                                        UDP/SRTP/SRTCP
                                    </td>
                                </tr>
                                <tr>
                                    <td><a href="sdkgw.us1.twilio.com" class="text-primary">sdkgw.us1.twilio.com</a></td>
                                    <td>443 WSS</td>
                                </tr>
                                <tr>
                                    <td><a href="ecs.us1.twilio.com" class="text-primary">ecs.us1.twilio.com</a></td>
                                    <td>443 HTTPS</td>
                                </tr>
                                <tr>
                                    <td>journey.fitt.ai</td>
                                    <td>
                                        443 (HTTPS) and 80
                                        <br>
                                        (HTTP)
                                    </td>
                                    <td>The fitt web application</td>
                                </tr>
                                <tr>
                                    <td>manage.fitt.ai</td>
                                    <td>
                                        443 (HTTPS) and 80
                                        <br>
                                        (HTTP)
                                    </td>
                                    <td>The fitt API endpoint for the web application</td>
                                </tr>
                                <tr>
                                  <td>content.fitt.ai</td>
                                  <td>
                                    443 (HTTPS) and 80
                                    <br>
                                    (HTTP)
                                  </td>
                                  <td>The fitt CDN providing the assets required during a journey.</td>
                                </tr>
                                <tr>
                                  <td>fitt-priv.s3.eu-west-1.amazonaws.com</td>
                                  <td>
                                    443 (HTTPS) and 80
                                    <br>
                                    (HTTP)
                                  </td>
                                  <td>A secure fitt endpoint where files are uploaded as part of the journey.</td>
                                </tr>
                                </tbody>
                            </table>
                        </card>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    export default {
        name: "TechnicalRequirements",
        components: {
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
            'tw-btn': () => import('@/components/Btn.vue'),
            // icon: () => import('@/components/display/Icon.vue'),
            'google-chrome': () => import('vue-material-design-icons/GoogleChrome.vue'),
            'firefox': () => import('vue-material-design-icons/Firefox'),
            'microsoft-edge': () => import('vue-material-design-icons/MicrosoftEdge.vue'),
            'microsoft-windows': () => import('vue-material-design-icons/MicrosoftWindows.vue'),
            'apple': () => import('vue-material-design-icons/Apple.vue'),
            card: () => import('@/components/Card.vue'),
            'tw-divider': () => import('@/components/Divider.vue'),
        },
        data: () => ({
            windowsSrc: null,
            macOsSrc: null
        }),
        methods: {
            goTo(address) {
                console.log(address);
                window.open(address, '_blank');
            }
        }
    }
</script>

<style scoped>
    /*th {*/
    /*    padding: 10px;*/
    /*    text-align: left;*/
    /*}*/

    /*td {*/
    /*    padding: 10px;*/
    /*}*/
</style>
